import { __exports as unitless_cjs_prod } from '../../../../_virtual/unitless.cjs.prod.js';
var hasRequiredUnitless_cjs_prod;
function requireUnitless_cjs_prod() {
  if (hasRequiredUnitless_cjs_prod) return unitless_cjs_prod;
  hasRequiredUnitless_cjs_prod = 1;
  Object.defineProperty(unitless_cjs_prod, "__esModule", {
    value: !0
  });
  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };
  unitless_cjs_prod.default = unitlessKeys;
  return unitless_cjs_prod;
}
export { requireUnitless_cjs_prod as __require };
//# sourceMappingURL=unitless.cjs.prod.js.map
